import Lighting from '../../../base/menu/airdome/Lighting';

const lighting: Lighting = {
  categoryName: 'Beleuchtung',
  current: 'Aktuell'
};

export default lighting;
